import { connect } from 'react-redux'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import VoucherSearch from './VoucherSearch'

const mapStateToProps = state => {
    return {
        tableData: selector.tableSelectorVoucher(state),
        voucherCode: selector.selectVoucherCode(state),
    }
}

const mapDispatchToProps = {
    onChangeVoucherCode: action.onVoucherCodeChange,
    onEnterVoucherCode: action.onVoucherCodeEnter,
}

export default connect(mapStateToProps, mapDispatchToProps)(VoucherSearch)



// WEBPACK FOOTER //
// ./src/modules/voucher/component/search/VoucherSearchContainer.js